import { forwardRef, useEffect, useState } from "react";
import { hrService } from "../../../services/hr.services";
import { IOption } from "Dashboard/domain/IOption";
import CreatableSelect from "react-select/creatable";

const EmployeeRoleSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      try {
        const roles = await hrService.getAllEmployeeRoles();
        const op = roles.map((role) => {
          return {
            label: role.roleName,
            value: role.roleId,
          };
        });
        setOptions(op);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        handleChange(values[0], null);
      } else setValueFunction(undefined);
    }
  }, [options, props.defaultValue]);

  const getValue = () => {
    if (value) {
      const values = options.filter((o) => o.value === value);
      if (values[0]) {
        return values[0];
      }
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option?.value);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  const createOption = async (name: string): Promise<IOption> => {
    try {
      const role = await hrService.createEmployeeRole({ roleName: name });
      return {
        label: role.roleName,
        value: role.roleId,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      isClearable
      menuPosition="fixed"
      styles={props.styles}
      ref={ref}
      formatCreateLabel={formatCreate}
      options={options}
      value={getValue()}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default EmployeeRoleSelectCreate;
